import {useContext} from "react";
import {IFeedbackContext,FeedbackContextState} from "../context/FeedbackContext";

export const useFeedback = () => useContext<FeedbackContextState>(IFeedbackContext)